import React from "react";
import { Link, useNavigate } from "react-router-dom";
import marginLogo from "../../assets/vectorlogo.png";
import "../../components/Checkout/CheckoutPanel.css";

const CheckoutCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mc-page">
      <div className="mc-page__inner mc__panel">
        <Link to="/" className="mc__brand" aria-label="lovestoria">
          <img src={marginLogo} alt="lovestoria" />
        </Link>

        <div className="mc__heading">
          <h1 className="mc__title">Платёж не завершён</h1>
        </div>

        <button
          type="button"
          className="mc__submit"
          onClick={() => navigate("/checkout")}
        >
          Попробовать снова
        </button>
      </div>
    </div>
  );
};

export default CheckoutCancel;
